import { http } from 'App/http';
import { objectToFormData } from 'App/helpers';
import pick from 'lodash/pick';

let eventFillableAttributes = [
    'id',
    'image',
    'image_url',
    'hide_spots',
    'is_closed',
    'is_private',
    'address',
    'zip',
    'city',
    'cal_id',
    'start',
    'end',
    'date',
    'endDate',
    'event_id',
    'currency',
    'name',
    'thumbnail_url',
    'has_image',
    'notes',
    'price',
    'send_receipt',
    'slug',
    'spots',
    'start',
    'userid',
    'vat',
    'vat_rate',
    'send_reminder_email',
    'send_reminder_sms',
    'product_danmark_id',
    'pay_before',
    'online_payment_reserve',
    'event_group',
    'payment_rates',
    'payment_rates_interval',
    'payment_rates_number',
    'vouchers',
    'practitioners',
    'waiting_list_enabled',
    'color',
    'fields',
    'tags',
];

export default {
    create(event) {
        let object_to_post = pick(event, eventFillableAttributes);

        return http.post(`/app/event`, objectToFormData(object_to_post));
    },

    get(id) {
        return http.get(`/app/event/${id}`);
    },

    prepareRecurring(event) {
        return http.post('/app/event/prepare-multiple', objectToFormData(event));
    },

    createRecurring(event) {
        return http.post('/app/event/execute-multiple', objectToFormData(event));
    },

    update(id, event) {
        let object_to_post = pick(event, eventFillableAttributes);

        // practitioners require special care
        if (object_to_post.practitioners && object_to_post.practitioners.length === 0) {
            object_to_post.practitioners = [null];
        }

        return http.post(`/app/event/${id}`, objectToFormData(object_to_post));
    },

    delete(id, cancellationData = {}) {
        if (cancellationData.hasOwnProperty('clients') && cancellationData.clients.length) {
            return http.post(`/app/event/${id}/delete-and-notify-clients`, {cancellation_data: cancellationData});
        } else {
            return http.delete(`/app/event/${id}`);
        }
    },

    moveEvent(event) {
        if (! event || ! event.id) {
            console.log('The event does not exist yet.');
            return;
        }

        return http.post(`/app/event/${event.id}/move`, {
                start: event.start.format(serverDatetimeFormat),
                end: event.end.format(serverDatetimeFormat),
            }).then(response => {
                toastr.success(response.data.success);
                return response;
            });
    },
};
